/**
 * Single source of truth for ServicePro brand colors needed as **literal** hex
 * values — Google Maps fill/stroke options, raw SVG fills, transactional email
 * HTML, console styling: the places the CSS/Tailwind design tokens can't reach.
 *
 * For normal DOM styling, use the Tailwind/theme tokens instead of these.
 * Importable from anywhere (web, api, jobsite-components) via the `/brand`
 * subpath export — kept dependency-free so the backend can import it without
 * pulling in the React component graph.
 */
const BRAND = {
  /** Primary brand yellow. */
  yellow: "#fdc700",
} as const;

export { BRAND };
